import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Overlay.scss';

class Overlay extends Component {
  static propTypes = {
    id: PropTypes.string,
    children: PropTypes.object,
    onHide: PropTypes.func,
    show: PropTypes.bool,
    className: PropTypes.string
  };

  componentDidMount() {
    document.addEventListener('keydown', e => this.closeOverlay(e));
  }

  UNSAFE_componentWillUnmount() {
    document.removeEventListener('keydown', e => this.closeOverlay(e));
  }

  closeOverlay = e => {
    if (typeof this.props.onHide !== 'function') {
      return;
    }

    if (e.key === 'Escape' || e.target.id === 'overlay') {
      this.props.onHide();
    }
  };

  render() {
    const { children, show } = this.props;
    const overlayId = this.props.id ? this.props.id : 'overlay';
    const titleClass = classNames({
      overlay: true,
      overlay__open: show,
      [this.props.className]: !!this.props.className
    });

    return (
      <div id={overlayId} className={titleClass} onClick={this.closeOverlay}>
        <div className="overlay__content">{children}</div>
      </div>
    );
  }
}

export default Overlay;
